/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_ResourcesInputs */

const en_mk_nav_resources = /** @type {(inputs: Mk_Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

const id_mk_nav_resources = /** @type {(inputs: Mk_Nav_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panduan`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Mk_Nav_ResourcesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_resources = /** @type {((inputs?: Mk_Nav_ResourcesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_ResourcesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_resources(inputs)
	return en_mk_nav_resources(inputs)
});